import { authHeader, handleResponse } from '../_helpers';
import { config } from "../../common/constant";
import { getPaymentEndpoint } from '../../common';
import { captureApiError } from '../../common';

export const homePageService = {
    getHomePageConfig,
    getHomePageSettings,
    getDonationWidgetData,
    getDonorWallData,
    getPayPartners,
    gethomePageConfiguration,
};

async function getHomePageConfig(payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
     const url = config.BASE_URL_DOMAIN + `/configuration-${version}/api/Configuration/configureEnrollPage`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return false
            }
        }).catch(error => {
            captureApiError(error)
            return false;
        });
}

async function gethomePageConfiguration(charityId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    const url = config.BASE_URL_WAKAF + "/v1/Home/getHomePageConfiguration?charityId=" + charityId;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return false
            }
        }).catch(error => {
            captureApiError(error)
            return false;
        });
}

async function getHomePageSettings() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    const url = config.BASE_URL + "/v1/Home/homePageConfiguration?charityId=" + config.MUIS_CHARITY_ID;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return false
            }
        }).catch(error => {
            captureApiError(error)
            return false;
        });
}

async function getDonationWidgetData(charityId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    const url = config.BASE_URL_WAKAF + "/v1/Donation/donationWidget?charityId=" + charityId;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {            
            return result.data;            
        }).catch(error => {
            captureApiError(error)
            return { status: 0 };
        });
}

async function getDonorWallData(pageNo, pageSize) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    const url = config.BASE_URL + "/v1/Donation/donorWall?charityId=" + config.MUIS_CHARITY_ID + "&pageNumber=" + pageNo + "&pageSize=" + pageSize;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return []
            }
        }).catch(error => {
            captureApiError(error)
            return [];
        });
}

async function getPayPartners(charityId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    // const url = BASE_URL + "/v1/Donation/getPayPartners?charityId=" + NGS_CHARITY_ID;
    const url = config.BASE_URL + "/v1/Donation/getPayPartners?charityId=" + charityId;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return []
            }
        }).catch(error => {
            captureApiError(error)
            return [];
        });
}